var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 44",
    xmlns: "http://www.w3.org/2000/svg",
    "data-om-id": "jsx:/https:/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89.claudeusercontent.com/v1/design/projects/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89/serve/app.jsx:26655:558:15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.06 0 0 8.06 0 18c0 12 18 26 18 26s18-14 18-26C36 8.06 27.94 0 18 0z",
    fill: "#d97a2b",
    "data-om-id": "jsx:/https:/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89.claudeusercontent.com/v1/design/projects/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89/serve/app.jsx:26732:559:17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 6,
    fill: "#fff",
    "data-om-id": "jsx:/https:/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89.claudeusercontent.com/v1/design/projects/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89/serve/app.jsx:26852:560:17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerOrange);
export default __webpack_public_path__ + "static/media/marker-orange.39629c7a22422b18170d3e20d0da2640.svg";
export { ForwardRef as ReactComponent };